import { FC } from 'react';
import { useLottie } from 'lottie-react';
import AchievementAnimationData from 'app/shared/lottieAnimations/achievement.json';

const animationStyles = {
  maxWidth: '100%',
  maxHeight: '500px',
  background: 'transparent',
  bottom: '0px',
};

type Props = {
  onAnimationDone: () => void;
};

const PostDetailAchievementAnimation: FC<Props> = ({ onAnimationDone }) => {
  const animationOptions = {
    animationData: AchievementAnimationData,
    loop: false,
    autoplay: true,
    onComplete: () => {
      onAnimationDone();
    },
  };

  const { View } = useLottie(animationOptions, animationStyles);

  return (
    <>
      <div
        id="post-detail-achievement-animation"
        className={
          'tw-pointer-events-none tw-fixed tw-left-0 tw-top-0 tw-z-50 tw-h-full tw-w-full'
        }
      >
        {View}
      </div>
    </>
  );
};

export default PostDetailAchievementAnimation;
